import { wpRESTPost } from './wpREST';

export async function postForm(params) {
  return wpRESTPost('local/v1/submit_form/', params);
}
